export default __webpack_public_path__ + "static/media/ultra teb final.450ff44e.svg";